"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PumbaaStaticScript = exports.PumbaaScript = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const atom_1 = require("../../atom");
const i18n_1 = require("../../i18n");
const ssr_1 = require("../../ssr");
const jotai_1 = require("jotai");
const DATA_SW = '/sw.js';
const DATA_ENV = __BUILD_TYPE__ === 'online' ? 'production' : 'ppe';
const PumbaaScript = () => {
    const { psm } = (0, jotai_1.useAtomValue)(atom_1.$AppIdConfig);
    const DATA_BUSINESS = psm;
    switch (__BUILD_REGION__) {
        case i18n_1.ClientBuildRegion.OCI:
            return ((0, jsx_runtime_1.jsx)("script", { async: true, src: "https://lf16-tiktok-web.tiktokcdn-us.com/obj/tiktok-web-tx/tiktok_privacy_protection_framework/loader/atsx/index.js", "data-business": DATA_BUSINESS, "data-sw": DATA_SW, "data-env": DATA_ENV, "data-region": "us-ttp" }));
        case i18n_1.ClientBuildRegion.VA:
            return ((0, jsx_runtime_1.jsx)("script", { async: true, src: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok_privacy_protection_framework/loader/atsx/index.js", "data-business": DATA_BUSINESS, "data-sw": DATA_SW, "data-env": DATA_ENV, "data-region": "va" }));
        case i18n_1.ClientBuildRegion.SG:
        default:
            return ((0, jsx_runtime_1.jsx)("script", { async: true, src: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok_privacy_protection_framework/loader/atsx/index.js", "data-business": DATA_BUSINESS, "data-sw": DATA_SW, "data-env": DATA_ENV, "data-region": "sg" }));
    }
};
exports.PumbaaScript = PumbaaScript;
const PumbaaStaticScript = () => {
    const { psm } = (0, jotai_1.useAtomValue)(atom_1.$AppIdConfig);
    const DATA_BUSINESS = psm;
    switch (__BUILD_REGION__) {
        case i18n_1.ClientBuildRegion.OCI:
            return ((0, jsx_runtime_1.jsx)(ssr_1.StaticHead, { children: (0, jsx_runtime_1.jsx)("script", { async: true, src: "https://lf16-tiktok-web.tiktokcdn-us.com/obj/tiktok-web-tx/tiktok_privacy_protection_framework/loader/atsx/index.js", "data-business": DATA_BUSINESS, "data-sw": DATA_SW, "data-env": DATA_ENV, "data-region": "us-ttp" }) }));
        case i18n_1.ClientBuildRegion.VA:
            return ((0, jsx_runtime_1.jsx)(ssr_1.StaticHead, { children: (0, jsx_runtime_1.jsx)("script", { async: true, src: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok_privacy_protection_framework/loader/atsx/index.js", "data-business": DATA_BUSINESS, "data-sw": DATA_SW, "data-env": DATA_ENV, "data-region": "va" }) }));
        case i18n_1.ClientBuildRegion.SG:
        default:
            return ((0, jsx_runtime_1.jsx)(ssr_1.StaticHead, { children: (0, jsx_runtime_1.jsx)("script", { async: true, src: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok_privacy_protection_framework/loader/atsx/index.js", "data-business": DATA_BUSINESS, "data-sw": DATA_SW, "data-env": DATA_ENV, "data-region": "sg" }) }));
    }
};
exports.PumbaaStaticScript = PumbaaStaticScript;
